<template>
   <v-select
        :items="eventBaseGroups"
        box
        :value="value"
        item-text="Name"
        @change="handleChange"
        item-value="id"
        multiple
        :label="label[$i18n.locale]"></v-select>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    props: ['value', 'label'],
    computed: {
        ...mapGetters([
			'eventBaseGroups'
		])
	},
    data() {
        return {}
    },
	methods: {
        handleChange (e) {
            this.$emit('input', e)
        }
	}
};
</script>
